import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { LuckyNumberService } from "src/app/services/lucky-number.service";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-lucky-slider3",
    templateUrl: "./lucky-slider3.component.html",
    styleUrls: ["./lucky-slider3.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class LuckySlider3Component implements OnInit {
  title: string;
  languageCode: string = "en";
  description: string;
  pageThreeData: any;
  buttonLabel: string;
  constructor(
    private router: Router,
    private luckyNumberService: LuckyNumberService,
    private matDialog: MatDialog,
    private authService: AuthService
  ) {
    this.authService?.userDetails$?.subscribe((user: any) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
    });
  }

  cancelSlider3(event) {
    event.stopPropagation();
    this.router.navigateByUrl("/mainTabs/tabs/syndicate");
  }

  nextSlider(event, nextSlider) {
    event.stopPropagation();
    if (nextSlider === 3) {
      this.matDialog.closeAll();
      this.router.navigateByUrl(this.pageThreeData?.button_link);
      this.luckyNumberService.showAvailableLn.next(true);
    } else this.router.navigateByUrl(`/syndicate/lucky-slider${nextSlider}`);
  }

  prevSlider() {
    this.router.navigateByUrl("/syndicate/lucky-slider2");
  }
  ngOnInit(): void {
    const isEmpty = (val: any) => val === null || !(Object.keys(val) || val).length;
    this.luckyNumberService.getOnboardData("lucky_number").subscribe((onBoardRef: Data) => {
      if (onBoardRef?.exists && !isEmpty(onBoardRef?.data())) {
        const pageThreeData = onBoardRef?.data();
        const pageThreeContent = pageThreeData?.lucky_numbers?.page_3;
        this.pageThreeData = pageThreeContent;
        const description = pageThreeContent?._description ? pageThreeContent?._description?.[this.languageCode] : pageThreeContent?.description;
        const title = pageThreeContent?._title ? pageThreeContent?._title?.[this.languageCode] : pageThreeContent?.title;
        this.buttonLabel = pageThreeContent?._button_label ? pageThreeContent?._button_label?.[this.languageCode] : pageThreeContent?.button_label;

        if (description) {
          this.authService.getDVFromString(description).then((dvString: string) => {
            if (dvString) {
              this.description = dvString;
            } else {
              return ''
            }
          }).catch((err) => {
            return err
          });
        }
        if (title) {
          this.authService.getDVFromString(title).then((dvString: string) => {
            if (dvString) {
              this.title = dvString;
            } else {
              return ''
            }
          }).catch((err) => {
            return err
          });
        }
      }
    });
  }
  closePopup() {
    this.matDialog.closeAll();
  }
}
